<script>

export default
{
    name: 'edit-actualities',

    created ()
    {
    },

    render () 
    {   
        return (
            <div id='edit-actualities' >
                <router-view />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    mounted ()
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#edit-actualities
{
    margin-top: 6vh;
    
    .OnDesktop({
        margin-top: 3vh;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });
}
</style>



// WEBPACK FOOTER //
// src/views/EditActualities.vue